/** @format */

const API = {
  getAlertUser: '/monitor/?Action=GetContact&Version=2021-01-01', // 获取联系人
  getUserGroup: '/monitor/?Action=GetContactGroup&Version=2021-01-01', // 获取联系组
  delAlertUse: '/monitor/?Action=DeleteAlertUser&Version=2021-01-01&Cap=1', // 删除联系人
  updateAlertUseStatus: '/monitorapi/users/updateAlertUserStatus', // 启用/禁用联系人
  getVerifyCode: '/monitor/?Action=SendVerify&Version=2021-01-01', // 发送验证码
  createAlertUser: '/monitor/?Action=CreateContact&Version=2021-01-01', // 创建联系人
  updateAlertUser: '/monitor/?Action=ModifyContact&Version=2021-01-01', //修改联系人
  createUserGroup: '/monitor/?Action=CreateContactGroup&Version=2021-01-01', //创建联系组
  updateUserGroup: '/monitor/?Action=UpdateContactGroup&Version=2021-01-01&Cap=1', // 编辑联系组
  delUserGroup: '/monitor/?Action=DeleteUserGroup&Version=2021-01-01&Cap=1' // 删除联系组
}
export default API
